import { SxProps } from "@mui/material";
import { DependencyList, useMemo } from "react";
import { merge } from "lodash";

export const useSxMergeStrict = <TTheme extends object = object>(
  factory: () => Array<SxProps<TTheme> | undefined>,
  deps: DependencyList
): SxProps<TTheme> => {
  return useMemo(() => {
    const parts = factory();
    return merge({}, ...parts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factory, ...deps]);
};
